import React, { ReactElement } from 'react'
import { AnimatePresence } from 'motion/react'

import { CartDrawerWrapper } from '@mindfulchefuk/features/Cart/components/CartDrawer/CartDrawerWrapper'
import { useChooseRecipesContext } from '@mindfulchefuk/onboarding/context/ChooseRecipesContext/ChooseRecipesContext'
import { OnboardingCartDrawerHeader } from '@mindfulchefuk/onboarding/components/OnboardingCartDrawer/OnboardingCartDrawerHeader'
import { OnboardingEmptyCart } from '@mindfulchefuk/onboarding/components/OnboardingCartDrawer/OnboardingEmptyCart'
import { OnboardingCartBasket } from '@mindfulchefuk/onboarding/components/OnboardingCartDrawer/OnboardingCartBasket'

export type TOnboardingCartDrawer = {
  isOpen: boolean
  onClose: () => void
}

export const OnboardingCartDrawer = ({
  isOpen,
  onClose,
}: TOnboardingCartDrawer): ReactElement => {
  const { selectedDeliveryDate, totalNumberOfRecipes, toggleCartDrawer } =
    useChooseRecipesContext()

  const isCartEmpty = totalNumberOfRecipes < 1

  return (
    <CartDrawerWrapper isOpen={isOpen} onClose={onClose}>
      <OnboardingCartDrawerHeader
        deliveryDate={selectedDeliveryDate}
        onClose={toggleCartDrawer}
      />
      <AnimatePresence mode="wait">
        {isCartEmpty && <OnboardingEmptyCart />}

        {!isCartEmpty && <OnboardingCartBasket />}
      </AnimatePresence>
    </CartDrawerWrapper>
  )
}
